export class ExtraInfo {

    created_by?: string;

    updated_by?: string;

    created_at?: string;

    updated_at?: string;
    
}
